var _path, _path2, _path3, _circle, _circle2, _circle3, _g, _use, _use2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcIndia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 900,
    height: 600,
    viewBox: "-45 -30 90 60",
    fill: "#2C2C6F",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Flag of India") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m-45-30h90v60h-90z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F15B25",
    d: "m-45-30h90v20h-90z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#006934",
    d: "m-45 10h90v20h-90z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 9.25
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#fff",
    r: 8
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 1.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0-8 .3 4.81409L0-.80235-.3-3.18591z"
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(7.5)",
    r: 0.35,
    cy: -8
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "scale(-1)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "rotate(15)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    transform: "rotate(30)"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    transform: "rotate(60)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    transform: "rotate(120)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcIndia);
export default __webpack_public_path__ + "static/media/ic_india.2e55f6780ca6eb2e7d727abff53cca77.svg";
export { ForwardRef as ReactComponent };